import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70077b25")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Thumbnail = _resolveComponent("Thumbnail")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Thumbnail, { item: _ctx.thumbnailItem }, null, 8, ["item"])
  ]))
})